// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  // Baseurl:            BaseUrl+":9085/",
  // BaseUrl:            BaseUrl+":7086/Admin/",
  // BaseUrl: "https://eorder.dev:8086/",
  // BaseUrl: "https://etlyoob.sy:8085/",
  BaseUrl: "https://etloob.sy:8090/",
  // BaseUrl: "https://192.168.132.43:7292/",
  // BaseUrl: "https://eorder.dev:8085/",

  // BaseUrl:'https://etloob.sy:8089/',
  firebase: {
    apiKey: "AIzaSyDfjup8pvlFNGjXyH10qEWVS5TRvsKwadw",
    authDomain: "etloobnew.firebaseapp.com",
    projectId: "etloobnew",
    storageBucket: "etloobnew.appspot.com",
    messagingSenderId: "786252500087",
    appId: "1:786252500087:web:0728fe02550955dca94a72",
    measurementId: "G-M06FZ63TBM",
    vapidKey:
      "BBifCXjbVBrfT8t7dlw1rypB75YpuxJV8wm_mzz1OJnyzJTgxj5-6i13X7X9E2OpVujySiFN0SK2Q0q-veARbsg",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
